import axiosInstance from "@/config/axios";
import type {
  AuthToken,
  Me,
  EvmSignInBody,
  AptosSignInBody,
  SignInBody,
  SignInResponse,
} from "@/shared/types/auth";

export const signinEvmRequest = async (
  body: EvmSignInBody
): Promise<AuthToken> => {
  const { data } = await axiosInstance.post("/auth/sign-in", body);
  return data;
};

export const signinAptosRequest = async (
  body: AptosSignInBody
): Promise<AuthToken> => {
  const { data } = await axiosInstance.post("/auth/aptos-sign-in", body);
  return data;
};

export const getMeRequest = async (): Promise<Me> => {
  const { data } = await axiosInstance.get("/users/me");
  return data;
};

export const signinRequest = async (
  body: SignInBody
): Promise<SignInResponse> => {
  const { data } = await axiosInstance.post("/admin/login", body);
  return data;
};
